import React from "react";
import {responsiveproductlistmobile5}  from "../../../utils/constant";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const handandleRedirect=(uri)=>{
    window.location.href = uri;
}
const Function =()=>{

    return(
    <div className="row mgt-10 banner-title pdt-10 pdx-10 mgx-0" id="tien-ich">
        <Carousel key="function"  responsive={responsiveproductlistmobile5}>
            <div className="banner-item">
                <div className='row' onClick={()=>handandleRedirect('/san-xu.html')}>
                    <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/san_xu.png" alt="icon"/></div>
                    <div className='col-12 d-flex in-f pdb-5'><span>Săn xu</span></div>
                </div>
            </div>
            <div className="banner-item">
                <div className='row' onClick={()=>handandleRedirect('/dong-gia.html')}>
                    <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/dong_gia.png" alt="icon"/></div>
                    <div className='col-12 d-flex in-f pdb-5'><span>Đồng giá</span></div>
                </div>
            </div>
            <div className="banner-item">
                <div className='row'  onClick={()=>handandleRedirect('/giam-gia.html')}>
                    <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giam_gia.png" alt="icon"/></div>
                    <div className='col-12 d-flex in-f pdb-5'><span>Giảm giá</span></div>
                </div>
            </div>
            <div className="banner-item">
                <div className='row'  onClick={()=>handandleRedirect('/hang-moi-ve.html')}>
                    <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/hang_moi.png" alt="icon"/></div>
                    <div className='col-12 d-flex in-f pdb-5'><span>Hàng mới</span></div>
                </div>
            </div>
            <div className="banner-item">
                <div className='row' onClick={()=>handandleRedirect('/he-thong-cua-hang.html')}>
                    <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cua_hang.png" alt="icon"/></div>
                    <div className='col-12 d-flex in-f pdb-5'><span>Cửa hàng</span></div>
                </div>
            </div>
            <div className="banner-item">
                <div className='row' onClick={()=>handandleRedirect('/dac-quyen.html')}>
                    <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/dac_quyen.png" alt="icon"/></div>
                    <div className='col-12 d-flex in-f pdb-5'><span>Đặc Quyền</span></div>
                </div>
            </div>
      </Carousel>
    </div>
    )
}
export default Function